<template>
  <span class="text-16px text-white lt-mobile:text-12px"><slot /></span>
</template>
